var $ = require('jquery');

$(function () {

    $('.column-content-preview-216__list--mobile').slick({
        arrows: true,
        centerMode: true,
        centerPadding: '30px',
        mobileFirst: true,
        responsive: [{
            breakpoint: 767,
            settings: 'unslick'
        }],
        rtl: window.GenericUtilities.isRTL()
    });
    // to get slick slider to initialize on screen resize
    // https://github.com/kenwheeler/slick/issues/1730
    $(window).on('resize orientationchange', function () {
        $('.column-content-preview-216__list--mobile').slick('resize');
    });

    $('.column-content-preview-216').each(function () {
        var t = $(this);
        if ($('html').hasClass('experience-editor') == false) {

            var showMore = t.find('.column-content-preview-216__show-more-less__more')[0];
            var showLess = t.find('.column-content-preview-216__show-more-less__less')[0];

            if (showMore != undefined) {
                showMore.onclick = function () {
                    t.toggleClass('show-more');
                }
            }

            if (showLess != undefined) {
                showLess.onclick = function () {
                    t.toggleClass('show-more');
                }
            }
        }
    });

    $('.column-content-preview-216__list__item__image').each(function () {
        if ($(this).find('img').length == 0) {
            $(this).addClass('no-image');
        }
    });
});
